import { render, staticRenderFns } from "./organisationApplications.vue?vue&type=template&id=5aa3b552&"
import script from "./organisationApplications.vue?vue&type=script&lang=js&"
export * from "./organisationApplications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports